<template>
  <div class="introduce_content">
    <div class="content_top flex Flexalign FlexBetween">
      <div class="flex flexcolumn flex-1 content_top_content">
        <div>亲爱的{{ userInfo.name }}同学</div>
        <div class="toverflows toverflow2">欢迎你加入课程《{{ courseDetail.courseName }}》，赶快开启学习之旅吧～</div>
      </div>
      <div class="btn_start cursor_pointer" @click="getMenu(2)">开始学习</div>
    </div>
    <div class="introduce_text">简介</div>
    <div class="introduce_title">《{{ courseDetail.courseName }}》即将开课</div>
    <div class="introduce_content" v-html="$Tools.handlerImg(courseDetail.courseIntro)" v-mathml></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5Introduce",

  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  props: {
    courseDetail: {},
  },
  watch: {
    // courseDetail: {
    //   handler(value) {
    //     if (value) {
    //       console.log(value.courseIntro);
    //       this.introduceHtml = value.courseIntro.replace(
    //         /<img/g,
    //         '<img style="max-width:100%; height:auto;" '
    //       );
    //     }
    //   },
    //   // immediate: true,
    //   deep: true,
    // },
  },

  data() {
    return {
      introduceHtml: "",
    };
  },

  mounted() {
    
  },

  methods: {
    getMenu(menu){
      this.$emit('getMenu',menu)
    }
  },
};
</script>
<style lang="scss" scoped>
.introduce_content {
  box-sizing: border-box;
  width: 762px;
  overflow: hidden;
  min-height: 892px;
  background: #ffffff;
  border-radius: 10px;

  .content_top {
    box-sizing: border-box;
    width: 722px;
    height: 80px;
    background: #f7f8fa;
    border-radius: 10px;
    margin: 20px;
    color: #333333;
    padding: 0 20px;
    .content_top_content{
      width: calc(100% - 160px);
    }

    .btn_start {
      width: 120px;
      height: 36px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 18px;
      line-height: 36px;
      text-align: center;
      color: #ffffff;
      font-size: 16px;
      // padding: 0 15px;
    }
  }

  .introduce_text {
    font-weight: bold;
    font-size: 20px;
    color: #111111;
    margin-left: 20px;
  }

  .introduce_title {
    font-size: 18px;
    color: #111111;
    margin: 10px 0 20px 20px;
  }
  .introduce_content {
    box-sizing: border-box;
    padding: 0 20px;
    color: #666666;
    // text-indent: 2ch;
    line-height: 29px;
  }
}
</style>
